import Image from "next/image";
import { LIBUM_AVATARS, LIBUM_ORG_AVATARS } from "@/lib/constants";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "./ui/tooltip";
import { useState } from "react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";

interface AvatarPopoverProps {
  avatar: string;
  type: "user" | "organization";
  onAvatarChange: (src: string) => void;
}

export default function AvatarPopover({
  avatar,
  type,
  onAvatarChange,
}: AvatarPopoverProps) {
  const avatars = type === "user" ? LIBUM_AVATARS : LIBUM_ORG_AVATARS;
  const [isOpen, setIsOpen] = useState(false);

  return (
    <DropdownMenu open={isOpen} onOpenChange={setIsOpen}>
      <DropdownMenuTrigger asChild>
        <button
          className={`mr-2 flex size-12 min-h-12 min-w-12 items-center justify-items-center overflow-hidden rounded-full border-4 border-amber-400 bg-background p-0 transition-transform hover:scale-110 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-primary active:scale-95 ${isOpen && "scale-110"}`}
        >
          <Image
            id="avatar"
            src={avatar}
            alt="Avatar"
            width={50}
            height={50}
            className="size-12 object-cover"
          />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent side="top" sideOffset={4}>
        <TooltipProvider delayDuration={200} disableHoverableContent={true}>
          <div className={`"flex p-2`}>
            <div
              className={`grid ${type === "user" ? "grid-cols-6" : "grid-cols-4"} justify-items-center gap-2`}
            >
              {avatars.map((avatar) => (
                <Tooltip key={avatar.name}>
                  <TooltipTrigger asChild>
                    <button
                      className={`mx-1 mt-1 size-12 items-center justify-center overflow-hidden rounded-full border-2 border-input bg-background p-0 transition-transform hover:scale-110 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-primary active:scale-95 dark:border-backgroundAccent`}
                      onClick={() => {
                        onAvatarChange(avatar.src);
                        setIsOpen(false);
                      }}
                    >
                      <Image
                        id="avatar"
                        src={avatar.src}
                        alt={avatar.name}
                        width={50}
                        height={50}
                        className="size-12 object-cover"
                      />
                    </button>
                  </TooltipTrigger>
                  <TooltipContent>
                    <p>{avatar.name}</p>
                  </TooltipContent>
                </Tooltip>
              ))}
            </div>
          </div>
        </TooltipProvider>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
